// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCHuMhWE2SwIqdL8YmKFtq-_Gv0BSCBro0",
    authDomain: "observatorio-uantof.firebaseapp.com",
    databaseURL: "https://observatorio-uantof.firebaseio.com",
    projectId: "observatorio-uantof",
    storageBucket: "observatorio-uantof.appspot.com",
    messagingSenderId: "610598131105"
  },
  algolia: {
    appId: 'Q82TNRN5ZD',
    apiKey: 'd5bb5423ff53f948fb604e468eccd69a',
    indexName: 'publicaciones',
    urlSync: false
  }
};




// WEBPACK FOOTER //
// ./src/environments/environment.ts